module.exports = __webpack_public_path__ + "img/elantra9.e863ac0d.jpeg";